import { useTranslation } from 'react-i18next';
import { WarningBanner } from './WarningBanner';

interface SuggestionsErrorBannerProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export function SuggestionsErrorBanner({
  onRetry,
  isRetrying = false,
}: SuggestionsErrorBannerProps) {
  const { t } = useTranslation();

  return (
    <WarningBanner
      title={t('result.suggestions.failedTitle')}
      description={t('result.suggestions.failedDescription')}
      actionLabel={t('result.suggestions.retry')}
      onAction={onRetry}
      isActing={isRetrying}
    />
  );
}
